export default __webpack_public_path__ + "static/media/mena20.9b2b3878.jpg";